/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  ILoadingMethods,
  LoadingService,
  IPaymentQueueMethods,
  PaymentQueueService,
  IPollingMethods,
  PollingService,
  ILockTokenMethods,
  LockTokenService,
  ICalloutTokenMethods,
  calloutTokenService,
  IMoveToPickerMethods,
  moveToPickerService,
  IGetPaymentStatusMethods,
  GetPaymentStatusService,
  IUnLockTokenMethods,
  UnLockTokenService,
  IMqqtMethods,
  MqqtService,
  ICompleteDistMethods,
  CompleteDistService,
  IGetTokenDetailsMethods,
  GetTokenDetailsService,
  IRevokeCalloutMethods,
  RevokeCalloutService,
} from "./components";

export type PaymentQueuePageAgent = IHeaderMethods &
  IStaticPageContentMethods &
  ILoadingMethods &
  IPaymentQueueMethods &
  IPollingMethods &
  ILockTokenMethods &
  ICalloutTokenMethods &
  IMoveToPickerMethods &
  IGetPaymentStatusMethods &
  IUnLockTokenMethods &
  IMqqtMethods &
  ICompleteDistMethods &
  IGetTokenDetailsMethods &
  IRevokeCalloutMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new StaticPageContentService(),
    new LoadingService(),
    new PaymentQueueService(),
    new PollingService(),
    new LockTokenService(),
    new calloutTokenService(),
    new moveToPickerService(),
    new GetPaymentStatusService(),
    new UnLockTokenService(),
    new MqqtService(),
    new CompleteDistService(),
    new GetTokenDetailsService(),
    new RevokeCalloutService(),
  ];
};

export const getAgent = () => {
  return createAgent<PaymentQueuePageAgent>({
    plugins: getPlugins(),
  });
};
